import React, { Component } from 'react';
import DynamicList from '../dynamic-list';
import { RichText } from 'prismic-reactjs';
import './style.css';
import { Watch } from 'scrollmonitor-react';
import AddAnimationClass from '../../shared/helpers/addAnimationClass';

export default Watch(class Services extends Component {
    firstTime = true;

    componentWillUpdate(nextProps) {
        if (typeof nextProps.content !== 'undefined' && this.firstTime) {
            this.props.startWatcher();
            this.firstTime = false;

        }
    }

    componentDidUpdate() {
        if (this._container.classList.contains("loading") && !this.firstTime) {
            this._container.classList.remove("loading");
        }
    }

    render() {
        let title;
        let description;
        let services;
        let servicesLimit = 5;
        let principes = {
            title: [
                {
                    text: ''
                }
            ],
            list: []
        };


        if (typeof this.props.content !== 'undefined') {
            title = this.props.content.data.title[0].text;
            description = RichText.render(this.props.content.data.description);

            this.props.content.data.body.map((e, i) => {
                switch (e.slice_type) {
                    case 'les_services':
                        services = this.props.content.data.body[i].items;
                        break;
                    case 'les_principes':
                        principes = this.props.content.data.body[i].primary;
                        break;
                    default:
                        break;
                }
            })
        }
        if (this.props.isInViewport) {
            AddAnimationClass(this._container, 200)
            this.props.stopWatcher();
        }
        return (
            <section id="services" className="services site-section loading" ref={(el) => { this._container = el; }}>
                <span className="angle__push-content"><span className="content"></span></span>
                <span className="decoration-line to-animate"></span>
                <div className="wrapper">
                    <h2 className="section-title to-animate">{title}</h2>
                    <span className="section-intro to-animate">{description}</span>
                    <DynamicList list={services} lang={this.props.lang} limit={4} />
                    <div className="principes to-animate">
                        <span className="principes__title">{principes.title[0].text}</span>
                        <ul className="principes-list">
                            {principes.list.map((e, i) => {
                                return (
                                    <li className="principes-list__item"
                                        key={i}
                                    >
                                        {e.text}
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </section>
        );
    }
});


// WEBPACK FOOTER //
// ./src/components/services/index.js